import { Skeleton as MuiSkeleton } from '@mui/material';
import type { SkeletonProps as MuiSkeletonProps } from '@mui/material/Skeleton';
import type { SxProps, Theme } from '@mui/material/styles';

export type SkeletonProps = MuiSkeletonProps;

const skeletonBaseSx: SxProps<Theme> = {
  bgcolor: (theme) =>
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.105)' : 'rgba(15, 23, 42, 0.105)',
  opacity: 1,
  transform: 'none',
  '&::after': {
    background: (theme) =>
      theme.palette.mode === 'dark'
        ? 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.055), transparent)'
        : 'linear-gradient(90deg, transparent, rgba(15, 23, 42, 0.045), transparent)',
  },
};

export const Skeleton = ({ animation = 'wave', sx, ...rest }: SkeletonProps): JSX.Element => (
  <MuiSkeleton
    animation={animation}
    sx={[skeletonBaseSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    {...rest}
  />
);
